module.exports = __webpack_public_path__ + "media/images/img_woman-9e3b7fe809038a2bc5a15a76b0731fc6.png";